// @flow

import { SEARCH_UPDATE, SEARCH_INFLIGHT_UPDATE } from "../actions"

export default ( state: any = {}, { type, queryType, response, enable }: any ) => {
  const storeState = state[ queryType ]
  switch ( type ) {
  case SEARCH_INFLIGHT_UPDATE:
    return {
      ...state,
      [ queryType ]: {
        ...storeState,
        inFlight: enable,
      },
    }
  case SEARCH_UPDATE:
    return {
      ...state,
      [ queryType ]: {
        ...storeState,
        ...response,
        data: [
          ...( storeState.data ? storeState.data : [] ),
          ...( response.data ? response.data : [] ),
        ],
      },
    }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/search.jsx